import { render, staticRenderFns } from "./payment-policies.vue?vue&type=template&id=599bdd77&scoped=true"
import script from "./payment-policies.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment-policies.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./payment-policies.vue?vue&type=style&index=0&id=599bdd77&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599bdd77",
  null
  
)

export default component.exports